"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBUG = exports.PARTITION = exports.EVENT_BUS_TABLE = void 0;
exports.SetEventBusTable = SetEventBusTable;
exports.SetEventBusDebug = SetEventBusDebug;
exports.EVENT_BUS_TABLE = process.env['CA_EVENT_BUS_TABLE'] || "";
exports.PARTITION = "event";
function SetEventBusTable(table) {
    exports.EVENT_BUS_TABLE = table;
}
exports.DEBUG = !!process.env['CA_EVENT_BUS_TABLE_DEBUG'];
function SetEventBusDebug(debug) {
    exports.DEBUG = debug;
}
//# sourceMappingURL=common.js.map